define('plugin/waiting-list/WaitingListPlugin',['require','lib/plugin/PluginAbstract','lib/WindowMessageListener','lib/AppRouter','handlebars'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
   // var ClientSignInModel = require('plugin/client-login/model/ClientSignInModel');
   // var ClientValidateLoginModel = require('plugin/client-login/model/ClientValidateLoginModel');
   // var WaitingListStep = require('plugin/client-login/step/WaitingListStep');
    //var WaitingListInfoView = require('plugin/client-login/view/WaitingListInfoView');
   // var WaitingListLayoutModuleView = require('plugin/waiting-list/view/WaitingListLayoutModuleView');
   // var WaitingListController = require('plugin/client-login/controller/WaitingListController');
   // var ClientTermsController = require('lib/terms/ClientTermsController');
    var WindowMessageListener = require('lib/WindowMessageListener');
    var AppRouter = require('lib/AppRouter');
    var Handlebars = require('handlebars');

    return PluginAbstract.extend({

        _clientModel: null,
        _popupSignInModel: null,
        _signInModel: null,
        _clientValidateLoginModel: null,
        // _waitingListRegions: {
        //     waitingList: '#sb_client_login_container'
        // },
        _waitingListModuleRegions: {
            waitingListForm: '#sb_waiting_list_info'
        },
        _controller: null,
        _termsController: null,
        _clientValidateTimeout: 60000,
        _clientModelReady : false,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initModel();
            this.initRoutes();
            this.initTemplateHelpers();
            //this.initOpenIdAuth();

            // this._termsController = ClientTermsController.getInstance({
            //     'client': this._clientModel
            // });
        },

        initTemplateHelpers: function () {
            //partials
            Handlebars.registerPartial('waitingListBookingInfoPart', jQuery('#waiting_list_booking_info_part').html());
        },

        /**
         * Initialize client model
         */
        initModel: function () {
            // this._popupSignInModel = new ClientSignInModel();
            // this._signInModel = new ClientSignInModel();
            // this._clientModel = this.getOption('clientModel');
            // this._clientValidateLoginModel = new ClientValidateLoginModel();
            //
            // this.listenTo(this._signInModel, 'sync', this.fetchClient);
            // this.listenTo(this._popupSignInModel, 'sync', this.fetchClient);
            // this.listenTo(this._clientValidateLoginModel, 'sync', this._checkWaitingList);

            //this.fetchClient();
        },

        getClientModel: function () {
            return this._clientModel;
        },

        /**
         * Initialize plugins modules
         */
        initModules: function (layout) {
            _.each(this._waitingListModuleRegions, function (selector, waitingListRegion) {
                layout.addRegion(waitingListRegion, selector);
            });

            // var view = new WaitingListLayoutModuleView({
            //     clientModel: this._clientModel,
            //     model: this._popupSignInModel
            // });

            // this.listenTo(view, 'signIn', _.bind(function (data) {
            //     this.performSignIn(data.view.getDataToSignIn(), this._popupSignInModel);
            // }, this));
            // this.listenTo(view, 'signOut', this.performSignOut);

           // layout.waitingListForm.show(view);
        },

        /**
         * Fetches client data from server
         */
        fetchClient: function () {
            this.resetErrors();

            //this._clientModel.fetch();
        },

        resetErrors: function () {
            this._clientModel.validationError = null;
            this._signInModel.validationError = null;
            this._popupSignInModel.validationError = null;
        },

        /**
         * Inits client login routes
         */
        initRoutes: function () {
            // this._controller = new WaitingListController({
            //     app: this.getOption('app'),
            //     clientModel: this._clientModel,
            //     signInModel: this._signInModel,
            //     handler: this
            // });
            //
            // var clientRouter = new AppRouter({
            //     appRoutes: {
            //         'client/remind-password(/)': 'remind',
            //         'client/profile(/:edit)(/)': 'profile',
            //         'client/sign-out(/)': 'signOut',
            //         'client/sign-in(/back/:back)(/message/:message)(/)': 'signIn'
            //     },
            //     menuItem: 'client_login',
            //     controller: this._controller
            // });
        },


        /**
         * Subscribe to event to client login information
         */
        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.addWaitingListView);
           // this.listenTo(this._clientModel, 'sync', this.updateClientInfo);
          //  this.listenTo(this._clientModel, 'change:is_logged_in', this._onWaitingListStatusChanged);

            //this.updateClientInfo();
        },

        /**
         * Before show details step view we add client login regions and view
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        addWaitingListView: function (step, view, region) {
            // this._detailsStep = step;
            // this._detailsStepView = view;
            // _.each(this._waitingListRegions, function (selector, waitingListRegion) {
            //     view.addRegion(waitingListRegion, selector);
            // });
            //
            // var infoView = new WaitingListInfoView({
            //     model: this._clientModel,
            //     step: this._detailsStep
            // });
            //
            // this.listenTo(infoView, 'signOut', this.performSignOut);
            //
            // this._detailsStepView.waitingList.show(infoView);
            // this._detailsStepView.ui.clientInfoForm.remove();
        },

        /**
         * Adds client registration/login step before client details.
         * It will show only if user is not logged in.
         *
         * @param Array steps
         * @return Array|null
         */
        modifySteps: function (steps) {
            // var index = _.indexOf(steps, 'details');
            // steps.splice(index, 0, 'client-login');
            //
            // return steps;
        },

        /**
         * Returns plugin step object
         *
         * @see lib/controller/booking/BaseStep
         * @param String step - step name
         * @param Object params - step parameters
         * @return BaseStep|null
         */
        getStep: function (step, params) {
            // if (step === 'client-login') {
            //     return new WaitingListStep(_.extend({}, params, {
            //         clientModel: this._clientModel,
            //         signInModel: this._signInModel,
            //         handler: this
            //     }));
            // }
        },






    });

});
